import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useSetUserCreditLimit = () => {
  const { data, call } = useApiPrivateRequest<boolean>((_) => true);
  const setCreditLimit = async (userId: string, limit: number) => {
    await call(`/admin/users/${userId}/creditLimit`, "PUT", {
      limit,
    });
  };
  return { isSet: data, setCreditLimit };
};
